import { CvpSettings } from "../settings/CvpSettings";
import { CvpLocale } from "./CvpLocale";

export enum PostMessageTypes {
  CVPEmbedReadyForSettings = "CVPEmbedReadyForSettings",
  CVPEmbedConfig = "CVPEmbedConfig",
  CVPRedirectHost = "CVPRedirectHost",
  CVPIframeStartLogout = "CVPIframeStartLogout",
  CVPIframeStopLogout = "CVPIframeStopLogout",
  CVPIframeStartLogin = "CVPIframeStartLogin",
  CVPIframeStopLogin = "CVPIframeStopLogin",
  CVPIframeLoginComplete = "CVPIframeLoginComplete",
  CVPIframeLogoutComplete = "CVPIframeLogoutComplete",
  CVPIframeAvailableContentHeight = "CVPIframeAvailableContentHeight",
}

export interface PostMessageCVPRedirectHost {
  type: PostMessageTypes.CVPRedirectHost;
  url: string;
  method: "push" | "replace";
  scrollToY?: number;
  hardRedirect: boolean;
}

export interface PostMessageCVPEmbedReadyForSettings {
  type: PostMessageTypes.CVPEmbedReadyForSettings;
  loadId: string;
  cvpIsLoggedIn: boolean;
}

export interface PostMessageCVPEmbedConfig {
  type: PostMessageTypes.CVPEmbedConfig;
  settingsComplete: CvpSettings;
  iframe_overrideLocale?: CvpLocale;
  sandbox?: boolean;
  hostUrl?: string;
  iframeAvailableContentHeight?: number;
}

export interface PostMessageCVPIframeStartLogout {
  type: PostMessageTypes.CVPIframeStartLogout;
  headerText: string;
  explanationText: string;
  buttonText: string;
  primaryColor: string;
  hoverColor: string;
  textColor: string;
  backgroundColor: string;
  panelBackgroundColor: string;
}

export interface PostMessageCVPIframeStopLogout {
  type: PostMessageTypes.CVPIframeStopLogout;
}

export interface PostMessageCVPIframeStartLogin {
  type: PostMessageTypes.CVPIframeStartLogin;
  headerText: string;
  explanationText: string;
  buttonText: string;
  primaryColor: string;
  hoverColor: string;
  textColor: string;
  backgroundColor: string;
  panelBackgroundColor: string;
}

export interface PostMessageCVPIframeStopLogin {
  type: PostMessageTypes.CVPIframeStopLogin;
}

export interface PostMessageCVPIframeLoginComplete {
  type: PostMessageTypes.CVPIframeLoginComplete;
}

export interface PostMessageCVPIframeLogoutComplete {
  type: PostMessageTypes.CVPIframeLogoutComplete;
}
